import type { GridSortModel } from '@mui/x-data-grid-pro';
import { ServerSortedField } from '@src/permits/permitSearch/ServerSortedField';
import { SortingMode } from '@src/permits/permitSearch/SortingMode';

export const sortingModeAssembler = (sortModel: GridSortModel): SortingMode => {
  return sortModel && sortModel[0]?.field !== ServerSortedField.EFFECTIVE_DATE
    ? SortingMode.CLIENT
    : SortingMode.SERVER;
};
